export enum TagModalStates {
  SUCCESS = "success",
  ERROR = "error",
  CLOSE = "close",
}

export enum ModalType {
  CREATE,
  UPDATE,
}
